class ProductImageSelector extends HTMLElement {
  constructor() {
    super();
    this.dots = this.querySelectorAll('.product-image-selector__dot');
    this.thumbnails = this.querySelectorAll('.product-image-selector__thumbnail');
    this.thumbnailsContainer = this.querySelector('.product-image-selector__thumbnails');
    this.prevButton = this.querySelector('.product-image-selector__nav-button--prev');
    this.nextButton = this.querySelector('.product-image-selector__nav-button--next');

    this.currentIndex = 0;
    this.init();
  }

  init() {
    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => this.selectImage(index));
      dot.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.selectImage(index);
        }
      });
    });

    this.thumbnails.forEach((thumbnail, index) => {
      thumbnail.addEventListener('click', () => this.selectImage(index));
      thumbnail.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.selectImage(index);
        }
      });
    });

    if (this.prevButton && this.nextButton && this.thumbnailsContainer) {
      this.prevButton.addEventListener('click', () => this.scrollThumbnails('prev'));
      this.nextButton.addEventListener('click', () => this.scrollThumbnails('next'));
      this.thumbnailsContainer.addEventListener('scroll', () => this.updateNavButtons());
      this.updateNavButtons();
    }

    const mediaGallery = document.querySelector(`media-gallery[id^="MediaGallery"]`);
    if (mediaGallery) {
      const observer = new MutationObserver(() => {
        this.syncWithMainGallery();
      });
      observer.observe(mediaGallery, {
        attributes: true,
        subtree: true,
        attributeFilter: ['class', 'aria-current']
      });
    }
  }

  selectImage(index) {
    this.currentIndex = index;

    this.dots.forEach((dot, i) => {
      dot.classList.toggle('active', i === index);
      dot.setAttribute('aria-current', i === index ? 'true' : 'false');
    });

    this.thumbnails.forEach((thumbnail, i) => {
      thumbnail.classList.toggle('active', i === index);
      thumbnail.setAttribute('aria-current', i === index ? 'true' : 'false');
    });

    const sectionId = this.dataset.sectionId;
    const mediaGallery = document.querySelector(`#MediaGallery-${sectionId}`);
    if (mediaGallery) {
      const slides = mediaGallery.querySelectorAll('.product__media-item');
      const reversedIndex = slides.length - 1 - index;
      if (slides[reversedIndex]) {
        const targetMediaId = slides[reversedIndex].dataset.mediaId;
        mediaGallery.setActiveMedia(targetMediaId, false);
      }
    }

    this.scrollThumbnailIntoView(index);
  }

  syncWithMainGallery() {
    const sectionId = this.dataset.sectionId;
    const activeSlide = document.querySelector(`#MediaGallery-${sectionId} .product__media-item.is-active`);

    if (activeSlide) {
      const slides = Array.from(document.querySelectorAll(`#MediaGallery-${sectionId} .product__media-item`));
      const activeIndex = slides.indexOf(activeSlide);
      const reversedIndex = slides.length - 1 - activeIndex;

      if (activeIndex !== -1 && reversedIndex !== this.currentIndex) {
        this.currentIndex = reversedIndex;

        this.dots.forEach((dot, i) => {
          dot.classList.toggle('active', i === reversedIndex);
          dot.setAttribute('aria-current', i === reversedIndex ? 'true' : 'false');
        });

        this.thumbnails.forEach((thumbnail, i) => {
          thumbnail.classList.toggle('active', i === reversedIndex);
          thumbnail.setAttribute('aria-current', i === reversedIndex ? 'true' : 'false');
        });

        this.scrollThumbnailIntoView(reversedIndex);
      }
    }
  }

  scrollThumbnailIntoView(index) {
    if (!this.thumbnailsContainer) return;

    const thumbnail = this.thumbnails[index];
    if (!thumbnail) return;

    const containerRect = this.thumbnailsContainer.getBoundingClientRect();
    const thumbnailRect = thumbnail.getBoundingClientRect();

    if (thumbnailRect.left < containerRect.left) {
      this.thumbnailsContainer.scrollLeft -= (containerRect.left - thumbnailRect.left) + 20;
    } else if (thumbnailRect.right > containerRect.right) {
      this.thumbnailsContainer.scrollLeft += (thumbnailRect.right - containerRect.right) + 20;
    }
  }

  scrollThumbnails(direction) {
    if (!this.thumbnailsContainer) return;

    const scrollAmount = this.thumbnailsContainer.offsetWidth * 0.8;
    const newScrollLeft = direction === 'next'
      ? this.thumbnailsContainer.scrollLeft + scrollAmount
      : this.thumbnailsContainer.scrollLeft - scrollAmount;

    this.thumbnailsContainer.scrollTo({
      left: newScrollLeft,
      behavior: 'smooth'
    });
  }

  updateNavButtons() {
    if (!this.prevButton || !this.nextButton || !this.thumbnailsContainer) return;

    const isAtStart = this.thumbnailsContainer.scrollLeft <= 0;
    const isAtEnd = this.thumbnailsContainer.scrollLeft + this.thumbnailsContainer.offsetWidth >= this.thumbnailsContainer.scrollWidth - 1;

    this.prevButton.disabled = isAtStart;
    this.nextButton.disabled = isAtEnd;
  }
}

customElements.define('product-image-selector', ProductImageSelector);
